export default __webpack_public_path__ + "static/media/friendsNcake_w320.2a8f36c2.jpeg";